import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isEmpty } from 'lodash';
import { filterPayments } from "../../components/PaymentContainer/components/PaymentSelection/components/PaymentMethodSection/utils";
import { SEPARATOR } from "../../../constants";
import { produce } from "../../../libs/immer";
import { findFirst } from "../../../utils/arrays";
import { recursiveMerge } from "../../../utils/recursiveMerge";
import { Content } from "../getContent/Content";
import { DEFAULT_TEXTS } from "../getContent/DEFAULT_TEXTS";
import { EPaymentMethodGranular } from "../getContent/constants";
import { getAllowedMethods } from "../getContent/utils";
var getId = function getId(method, id) {
  if (!id) return method;
  return [method, SEPARATOR, id].join('');
};
export var getInitialize = function getInitialize(_ref) {
  var fetchContent = _ref.fetchContent,
    getContentInstance = _ref.getContentInstance,
    getIsLoggedIn = _ref.getIsLoggedIn,
    fetchSavedCards = _ref.fetchSavedCards,
    fetchSbpBindings = _ref.fetchSbpBindings,
    fetchSberpayBindings = _ref.fetchSberpayBindings,
    getWindow = _ref.getWindow;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _content, contentInstance, content, paymentMethods, options, isLoggedIn, getLogo, getSavedCards, getSbpBindings, getSberBinding, quickOptions;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fetchContent().then(function (content) {
            return recursiveMerge(DEFAULT_TEXTS, content);
          });
        case 2:
          _content = _context4.sent;
          contentInstance = getContentInstance();
          contentInstance.initialize(_content);
          content = contentInstance.getData();
          paymentMethods = getAllowedMethods(getWindow, getIsLoggedIn, function () {
            return content;
          }); // get payments
          options = filterPayments([EPaymentMethodGranular.SBP, EPaymentMethodGranular.SberPay, EPaymentMethodGranular.Card].map(function (id) {
            var _content$paymentMetho;
            var option = (_content$paymentMetho = content.paymentMethodsOptions[id]) !== null && _content$paymentMetho !== void 0 ? _content$paymentMetho : {
              id: '',
              title: '',
              iconSrc: ''
            };
            console.warn({
              option: option
            });
            return {
              id: option.id,
              text: {
                title: option.title
              },
              iconUrl: option.iconSrc
            };
          }), paymentMethods); // get quick payments
          // check if logged in
          isLoggedIn = getIsLoggedIn(); // saved cards
          getLogo = function getLogo(paymentSystem) {
            var _content$cardLogos$fi;
            return (_content$cardLogos$fi = content.cardLogos.find(function (_ref3) {
              var id = _ref3.id;
              return id === paymentSystem.toLocaleLowerCase();
            })) === null || _content$cardLogos$fi === void 0 ? void 0 : _content$cardLogos$fi.src;
          };
          getSavedCards = /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _yield$fetchSavedCard, cards;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (isLoggedIn) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return", []);
                  case 2:
                    _context.prev = 2;
                    if (paymentMethods.includes(EPaymentMethodGranular.SavedCard)) {
                      _context.next = 5;
                      break;
                    }
                    return _context.abrupt("return", []);
                  case 5:
                    _context.next = 7;
                    return fetchSavedCards();
                  case 7:
                    _yield$fetchSavedCard = _context.sent;
                    cards = _yield$fetchSavedCard.cards;
                    return _context.abrupt("return", (cards || []).filter(function (o) {
                      return !!o.token;
                    }).map(function (o) {
                      var _content$paymentMetho2, _content$paymentMetho3, _ref5;
                      return {
                        id: getId(EPaymentMethodGranular.SavedCard, o.token),
                        text: {
                          title: (_content$paymentMetho2 = (_content$paymentMetho3 = content.paymentMethodsOptions.boundCards) === null || _content$paymentMetho3 === void 0 ? void 0 : _content$paymentMetho3.title) !== null && _content$paymentMetho2 !== void 0 ? _content$paymentMetho2 : '',
                          subtitle: [o.paymentSystem, o.last4].filter(Boolean).join(' ')
                        },
                        iconUrl: (_ref5 = o.paymentSystem && getLogo(o.paymentSystem)) !== null && _ref5 !== void 0 ? _ref5 : undefined
                      };
                    }));
                  case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](2);
                    console.error(_context.t0);
                    return _context.abrupt("return", []);
                  case 16:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[2, 12]]);
            }));
            return function getSavedCards() {
              return _ref4.apply(this, arguments);
            };
          }(); // sbp bindings
          getSbpBindings = /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var _yield$fetchSbpBindin, sbpBindings, addSbpBindingAllowed;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (isLoggedIn) {
                      _context2.next = 2;
                      break;
                    }
                    return _context2.abrupt("return", []);
                  case 2:
                    _context2.prev = 2;
                    if (paymentMethods.includes(EPaymentMethodGranular.SBPBinding)) {
                      _context2.next = 5;
                      break;
                    }
                    return _context2.abrupt("return", []);
                  case 5:
                    _context2.next = 7;
                    return fetchSbpBindings();
                  case 7:
                    _yield$fetchSbpBindin = _context2.sent;
                    sbpBindings = _yield$fetchSbpBindin.list;
                    addSbpBindingAllowed = _yield$fetchSbpBindin.addSbpBindingAllowed;
                    Content.getInstance().initialize(produce(content, function (draft) {
                      draft.sbpPopup.request.createBinding = addSbpBindingAllowed;
                    }));
                    return _context2.abrupt("return", (sbpBindings || []).filter(function (b) {
                      return !!b.bindingId;
                    }).map(function (b) {
                      var _content$paymentMetho4, _content$paymentMetho5, _b$bankName, _content$paymentMetho6, _content$paymentMetho7;
                      return {
                        id: getId(EPaymentMethodGranular.SBPBinding, b.bindingId),
                        text: {
                          title: (_content$paymentMetho4 = (_content$paymentMetho5 = content.paymentMethodsOptions.sbp) === null || _content$paymentMetho5 === void 0 ? void 0 : _content$paymentMetho5.title) !== null && _content$paymentMetho4 !== void 0 ? _content$paymentMetho4 : '',
                          subtitle: (_b$bankName = b.bankName) !== null && _b$bankName !== void 0 ? _b$bankName : ''
                        },
                        iconUrl: (_content$paymentMetho6 = (_content$paymentMetho7 = content.paymentMethodsOptions.sbp) === null || _content$paymentMetho7 === void 0 ? void 0 : _content$paymentMetho7.iconSrc) !== null && _content$paymentMetho6 !== void 0 ? _content$paymentMetho6 : undefined
                      };
                    }));
                  case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](2);
                    console.error(_context2.t0);
                    return _context2.abrupt("return", []);
                  case 18:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[2, 14]]);
            }));
            return function getSbpBindings() {
              return _ref6.apply(this, arguments);
            };
          }(); // sberpay bindings
          getSberBinding = /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var _findFirst, _content$paymentMetho8, _content$paymentMetho9, _quickSberPayOption$m, _content$paymentMetho10, _content$paymentMetho11, _yield$fetchSberpayBi, quickSberPayOption;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (isLoggedIn) {
                      _context3.next = 2;
                      break;
                    }
                    return _context3.abrupt("return", []);
                  case 2:
                    _context3.prev = 2;
                    if (paymentMethods.includes(EPaymentMethodGranular.SberPayBinding)) {
                      _context3.next = 5;
                      break;
                    }
                    return _context3.abrupt("return", []);
                  case 5:
                    _context3.next = 7;
                    return fetchSberpayBindings();
                  case 7:
                    _yield$fetchSberpayBi = _context3.sent;
                    quickSberPayOption = _yield$fetchSberpayBi.data;
                    if (quickSberPayOption.bindingId) {
                      _context3.next = 11;
                      break;
                    }
                    return _context3.abrupt("return", []);
                  case 11:
                    return _context3.abrupt("return", (_findFirst = findFirst([quickSberPayOption && quickSberPayOption.bindingId && [{
                      id: getId(EPaymentMethodGranular.SberPayBinding, quickSberPayOption.bindingId),
                      text: {
                        title: (_content$paymentMetho8 = (_content$paymentMetho9 = content.paymentMethodsOptions[EPaymentMethodGranular.SberPay]) === null || _content$paymentMetho9 === void 0 ? void 0 : _content$paymentMetho9.title) !== null && _content$paymentMetho8 !== void 0 ? _content$paymentMetho8 : '',
                        subtitle: (_quickSberPayOption$m = quickSberPayOption.maskedPan) === null || _quickSberPayOption$m === void 0 ? void 0 : _quickSberPayOption$m.slice(-4)
                      },
                      iconUrl: (_content$paymentMetho10 = (_content$paymentMetho11 = content.paymentMethodsOptions.sberPay) === null || _content$paymentMetho11 === void 0 ? void 0 : _content$paymentMetho11.iconSrc) !== null && _content$paymentMetho10 !== void 0 ? _content$paymentMetho10 : undefined
                    }]])) !== null && _findFirst !== void 0 ? _findFirst : []);
                  case 14:
                    _context3.prev = 14;
                    _context3.t0 = _context3["catch"](2);
                    console.error(_context3.t0);
                    return _context3.abrupt("return", []);
                  case 18:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, null, [[2, 14]]);
            }));
            return function getSberBinding() {
              return _ref7.apply(this, arguments);
            };
          }();
          _context4.next = 15;
          return getSbpBindings();
        case 15:
          _context4.t0 = _context4.sent;
          _context4.next = 18;
          return getSavedCards();
        case 18:
          _context4.t1 = _context4.sent;
          _context4.next = 21;
          return getSberBinding();
        case 21:
          _context4.t2 = _context4.sent;
          quickOptions = [_context4.t0, _context4.t1, _context4.t2].flat();
          return _context4.abrupt("return", {
            options: options.filter(function (o) {
              if (o.id !== EPaymentMethodGranular.SberPay) return true;
              return !!isEmpty(quickOptions.find(function (quickOption) {
                return quickOption.id.includes(EPaymentMethodGranular.SberPayBinding);
              }));
            }),
            quickOptions: quickOptions
          });
        case 24:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};